import React from 'react';
import QuestionnaireScoring from '../../containers/Questionnaires/QuestionnaireScoring';
import { withAuth } from '../../containers/Authenticated';


class QuestionnaireScoringPageInternal extends React.Component {
  render() {
    return <QuestionnaireScoring />;
  }
}

export const QuestionnaireScoringPage = withAuth(QuestionnaireScoringPageInternal);
